import {
  distinctUntilChanged,
  map,
  Observable,
  pipe,
  UnaryFunction,
} from 'rxjs';

export function rxDistinctJSONStringify<T>(): UnaryFunction<
  Observable<T>,
  Observable<T>
> {
  return pipe(
    // we stringify separately, so that changes by object reference are still detected, If we stringify it while comparing,
    // the already emitted value might have changed in the same way as the new value and distinctUntilChanged would not detect it
    map((value) => ({ value, stringified: JSON.stringify(value) })),
    distinctUntilChanged((a, b) => a.stringified === b.stringified),
    map((value) => value.value),
  );
}
